import { ModalGallery } from ".";
import { Component } from "../../helpers/compiler";

@Component({ className: 'js-modal-gallery' })
export class ModalGalleryComponent {
    constructor(private element: HTMLElement) {
        new ModalGallery(element);
    }
}